import React from 'react';
import {Field, useFormikContext} from 'formik';

type Props = {
	text: string;
	checked: boolean;
	name: string;
	onChange?: (checked: boolean) => void;
};
const RowCheckboxInPopupFilter: React.FC<Props> = ({checked, text, name, onChange}) => {
	const {setFieldValue} = useFormikContext();
	const handleClick = (event: React.SyntheticEvent<HTMLInputElement>) => {
		const checked = event.currentTarget.checked;
		setFieldValue(name, checked);
		// Вызываем кастомный обработчик если он передан
		if (onChange) {
			onChange(checked);
		}
	};

	return (
		<div className="form-filter__item form-filter__item-checkbox">
			<div className="checkbox">
				<span className="checkbox__label">{text}</span>
				<Field
					type="checkbox"
					name={name}
					checked={checked}
					className="checkbox__input"
					onClick={handleClick}
				/>
			</div>
		</div>
	);
};

export default RowCheckboxInPopupFilter;
